export default __webpack_public_path__ + "static/Maurice Gelden-2 new-a9404ef29ffa0355b7960e0bf043b30b.jpg";